document.addEventListener('DOMContentLoaded', function() {
  // Get reference to all menu components
  const navToggle = document.getElementById('nav-toggle');
  const navContainer = document.getElementById('navbar');
  const navListContainer = document.querySelector('#navbar nav');
  const navLinks = document.getElementsByClassName('nav-link');
  const navEntryContainers = document.getElementsByClassName('nav-entry-container');

  if (!navContainer) {
    // Page does not contain a nav bar, stop here
    return;
  }

  // Open / close menu
  navToggle.addEventListener('click', () => {
    toggleMenu();
  });

  // Close menu on link-click
  for (let el of navLinks) {
    el.addEventListener('click', () => {
      toggleMenu(false);
    });
  }

  // Hover dropdown
  Array.from(navEntryContainers).forEach(entry => {
    const dropdown = entry.querySelector('.subnav-list');
    if (dropdown) {
      entry.addEventListener('mouseover', () => {
        dropdown.style.height = dropdown.scrollHeight + 'px';
      });

      entry.addEventListener('mouseout', () => {
        dropdown.style.height = 0;
      });
    }
  });

  function toggleMenu(open) {
    const navToggleClass = 'active';
    const navContainerClass = 'open';
    if (open === true) {
      // Add all
      navToggle.classList.add(navToggleClass);
      navContainer.classList.add(navContainerClass);
      document.body.style.overflow = 'hidden';
    } else if (open === false) {
      // Remove all
      navToggle.classList.remove(navToggleClass);
      navContainer.classList.remove(navContainerClass);
      document.body.style.overflow = 'visible';
    } else {
      // Nothing was set, simply toggle current state
      const wasOpen = navToggle.classList.contains(navToggleClass);
      navToggle.classList.toggle(navToggleClass);
      navContainer.classList.toggle(navContainerClass);
      document.body.style.overflow = wasOpen ? 'visible' : 'hidden';
    }
  }

  // Close the menu on window resize
  window.addEventListener('resize', () => {
    if (navListContainer.clientHeight / window.innerHeight < 0.33) {
      // Nav container is smaller, that means the desktop breakpoint was hit, menu should be closed
      toggleMenu(false);
    }
  });
});
